import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Lottie } from 'lottie-react';
import { loadAnimation, recolorLottie } from '../utils/lottie';

/**
 * Единый компонент анимированных иконок из static/icon_set.
 * name — имя файла без .json; playOnHover — анимация только по наведению (пункты меню),
 * иначе автоплей (лоадеры и всё остальное).
 * tone — палитра перекраски: 'brand' (синий, по умолчанию), 'onDark' (светлый, для шапки),
 * 'danger' (красный, для ошибок), 'none' (оставить авторские цвета).
 */
function AnimatedIcon({ name, size = 32, playOnHover = false, tone = 'brand', loop = true, style, title }) {
  const [data, setData] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    let alive = true;
    loadAnimation(name).then((json) => { if (alive) setData(json); }).catch(() => {});
    return () => { alive = false; };
  }, [name]);

  const src = useMemo(() => (data && tone !== 'none' ? recolorLottie(data, tone) : data), [data, tone]);

  const box = { display: 'inline-block', width: size, height: size, verticalAlign: 'middle', lineHeight: 0, ...style };
  if (!src) {
    return <span style={box} aria-hidden="true" />;
  }

  const hoverProps = playOnHover ? {
    onMouseEnter: () => { const h = ref.current; if (h && h.play) h.play(); },
    onMouseLeave: () => { const h = ref.current; if (h && h.stop) h.stop(); },
  } : {};

  return (
    <span style={box} title={title} {...hoverProps}>
      <Lottie lottieRef={ref} src={src} loop={loop} autoplay={!playOnHover} style={{ width: size, height: size }} />
    </span>
  );
}

export default AnimatedIcon;
